export default "__VITE_ASSET__DHtM9zof__"